<script lang="ts">
  /** @type {Props} */
  import type { Snippet } from 'svelte';

  interface Props {
    children: Snippet;
    right?: Snippet;
  }

  let { children, right }: Props = $props();
</script>

<div class="bg-background sticky top-0 z-10 flex items-center justify-between gap-5 pb-2">
  <div class="flex items-center gap-2">
    {@render children()}
  </div>
  {#if right}
    <div class="flex items-center gap-2">
      {@render right()}
    </div>
  {/if}
</div>
